<script>
import IconCallCenter from "@js/components/Icons/IconCallCenter.vue";
import IconPhone from "@js/components/Icons/IconPhone.vue";
import IconWhatsApp from "@js/components/Icons/IconWhatsApp.vue";
import IconTelegram from "@js/components/Icons/IconTelegram.vue";
import {useCallbackFormsStore} from "@js/store/CallbackFormsStore.js";

export default {
    name: "Contact247",
    components: {IconPhone, IconCallCenter, IconTelegram, IconWhatsApp},
    setup(){
        const callbackStore = useCallbackFormsStore()

        return {callbackStore}
    },
}
</script>

<template>
    <div class="bg-[#f4f4f6]">
        <div class="p-5 bg-img border border-gray-200 rounded-lg shadow-sm">
            <div class="bg-white rounded-lg w-20 h-20 flex items-center justify-center mb-3">
                <IconCallCenter class="w-12 h-12 text-indigo-600"/>
            </div>
            <div class="text-gray-700 text-2xl font-semibold mb-1">
                Мы на связи 24/7
            </div>
            <div class="text-base text-gray-700 font-medium leading-tight mb-4">
                Получите консультацию <br/>
                от наших экспертов
            </div>
            <button type="button" @click.prevent="callbackStore.showCallbackPopup"
                    class="w-full flex justify-center items-center text-white border-2 border-indigo-600 bg-indigo-600 hover:bg-transparent hover:text-indigo-600 font-medium rounded-lg text-md px-10 p-2 focus:outline-none transition mb-4">
                <IconPhone class="me-2"/>
                Заказать звонок
            </button>
            <div class="flex items-center justify-between">
                <div class="leading-tight text-gray-700 text-[13px] font-semibold">
                    Вопросы по товарам<br/> заказам и доставке
                </div>
                <div>
                    <ul class="flex flex-row font-medium mt-0 space-x-2 text-sm">
                        <li class="w-10 h-10 bg-whatsapp rounded-lg">
                            <a href="https://api.whatsapp.com/send/?phone=79256649222&text&type=phone_number&app_absent=0"
                               class="w-full h-full flex items-center justify-center"
                               aria-label="WhatsApp" title="WhatsApp">
                                <IconWhatsApp class="w-6 h-6 text-white"/>
                            </a>
                        </li>
                        <li class="w-10 h-10 bg-telegram rounded-lg">
                            <a href="https://t.me/Dorozhnyeplity" target="_blank" aria-label="Telegram" title="Telegram"
                               class="w-full h-full flex items-center justify-center">
                                <IconTelegram class="w-5 h-5 text-white -ms-0.5"/>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.bg-img {
    background: url(https://dsk-stolica.ru//images/chapter-decor/chapter-decor-10.png) no-repeat 220% -100%;
    background-size: 245px 258px;
}
</style>
